import type { TechniqueEntry } from '../schema';

// review: 18 Aug selectability pass pending clinical review — the baseline moved from
// prerequisite to the method's opening beat, which is a new clinical decision.
export const normativeFeedback: TechniqueEntry = {
  key: 'normative_feedback',
  version: '0.3',
  name: 'Normative feedback',
  pillar: 'Practical',
  serves:
    "Placing the member's self-reported baseline against the health guidelines, once, as context: the starting line, never a judgment.",
  method: [
    "If the typical week is not already in the room in the member's own numbers, establish it first, plainly and without ceremony: one question, their estimate, no probing for precision; the comparison runs only on a number the member has given, never one estimated or inferred for them.",
    'State their pattern back plainly first, in their own figures, using the day-by-day spread where it sharpens the picture (weekend concentration vs steady-through-the-week).',
    'Ask first where the flow allows: whether they would like to hear how their week compares with the health guidelines.',
    'Then the comparison, once, in plain words, naming the source in full (the National Institutes of Health guidelines, never an acronym): low-risk drinking means no more than 14 drinks in a week and no more than 4 in a day [7 and 3 for women], noting plainly when their typical week sits above.',
    'Frame it as a starting line, never a verdict; then move on.',
  ],
  never: [
    'Say it once; never repeat it, never moralise it.',
    'Never cite studies, surveys, or percentages.',
    "Never assert timing or patterns beyond what the counts and the member's own words show.",
  ],
  requiresFirst: [
    {
      kind: 'conversation',
      clause:
        "The member's typical use pattern in the room in their own numbers (a typical week's drinks), or a baseline on record. If the quantity has not yet been named, the method's opening beat elicits it before any comparison is made.",
    },
  ],
  doneWhen:
    'The comparison delivered once and heard as context: the conversation moved on without the member defending their number.',
  firstMove: null,
  exemplars: [],
  appliesTo: ['base', 'journey'],
  // The method IS the NIH numeric comparison — a non-numeric variant for another program is a
  // new version, not a looser gate.
  programs: ['alcohol'],
  signature: null,
  source:
    'agents/cab/sona/prompt.md (baseline & guidelines beat, risk-signal rules), agents/intake/sona-v2/prompt.md (ask-first, alcohol-only)',
};
